
import React from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import MentorsTable from "./MentorsTable";
import { MentorApplication } from "./MentorTypes";

interface MentorsListCardProps {
  applications: MentorApplication[];
  loading: boolean;
  onViewDetails: (mentor: MentorApplication) => void;
  onUpdateStatus: (id: string, status: 'approved' | 'rejected') => Promise<void>;
}

const MentorsListCard: React.FC<MentorsListCardProps> = ({
  applications,
  loading,
  onViewDetails,
  onUpdateStatus
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Mentor Applications</CardTitle>
        <CardDescription>
          Review and manage mentor applications
        </CardDescription>
      </CardHeader>
      <CardContent>
        {loading ? (
          <div className="flex justify-center my-12">
            <div className="animate-spin h-8 w-8 border-2 border-primary rounded-full border-t-transparent"></div>
          </div>
        ) : applications.length === 0 ? (
          <div className="text-center my-12">
            <p className="text-muted-foreground">No applications yet</p>
          </div>
        ) : (
          <MentorsTable 
            applications={applications} 
            onViewDetails={onViewDetails} 
            onUpdateStatus={onUpdateStatus} 
          />
        )}
      </CardContent>
    </Card>
  );
};

export default MentorsListCard;
